var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "relative w-100" }, [
    _c("div", { staticClass: "relative swiper-bg" }, [
      _c(
        "div",
        { staticClass: "relative mw8-25 center" },
        [
          _c("div", {
            staticClass: "swiper-button-prev pointer outline-0",
            attrs: { slot: "button-prev" },
            slot: "button-prev",
          }),
          _vm._v(" "),
          _c("img", {
            staticClass: "absolute swiper-bubble",
            attrs: { src: "/uploads/OL19_Bubbles-web.png" },
          }),
          _vm._v(" "),
          _c(
            "swiper",
            { ref: "mySwiper", attrs: { options: _vm.swiperOptions } },
            _vm._l(_vm.accolades_carousel.accolades, function (item, index) {
              return _c(
                "swiper-slide",
                {
                  key: "press-accolades-swiper-slide-" + index,
                  style: { height: _vm.height },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "db absolute abs-vert-center is-white w-100",
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "is-lorano-bold f15px is-light-blue2" },
                        [_vm._v("Accolades")]
                      ),
                      _vm._v(" "),
                      _c("p", {
                        staticClass:
                          "is-tablet-narrow-semi-bold f3 f1-ns pv4 lh-title",
                        domProps: { innerHTML: _vm._s(item.text) },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "f25px is-tablet-cond-bold" }, [
                        _vm._v("-" + _vm._s(item.source)),
                      ]),
                    ]
                  ),
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "swiper-button-next pointer outline-0",
            attrs: { slot: "button-next" },
            slot: "button-next",
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }